<app-sts-header-banner *ngIf="showHeaderBanner"></app-sts-header-banner>

<div class="sts sts-cover" [ngClass]="{'sts-cover-ie11': isIE11}" [ngStyle]="{backgroundImage: background}">

  <!-- main -->

  <main class="main-content container-fluid sts-object relative">



    <div class="row h-100">
      <div class="col-lg-11 offset-lg-13 app-padding">
        <!-- Router Outlet -->
        <div class="dtb">
          <div class="dtr">
            <div class="dtd">

              <!-- ** -->
              <div class="router-container">
                <div>
                  <app-sts-header *ngIf="showHeaderNormal"></app-sts-header>
                </div>
                <router-outlet id="main-app-content" tabindex="0"></router-outlet>
              </div>
              <!-- ** -->

            </div>
          </div>
        </div>


      </div>
    </div>

  </main>



</div>

<!-- footer -->
<app-sts-footer></app-sts-footer>
